<div class="tooltip" (click)="onClicked()"></div>
